import {
  MenuItem,
  TextField,
} from "@mui/material";

export const MultiSelectField = ({
  field,
  value,
  onChange,
}) => {

  const options =
    field?.options || {};

  const optionKeys =
    Object.keys(options);

  return (
    <TextField
      label={field.label}
      value={value ?? []}
      onChange={(e) =>
        onChange(e.target.value)
      }
      select
      fullWidth
      size="small"
      margin="normal"
      SelectProps={{
        multiple: true,

        renderValue: (
          selected,
        ) => {

          if (
            !Array.isArray(selected)
          ) {
            return "";
          }

          return selected
            .map(
              (v) =>
                options[
                  String(v)
                ] || v,
            )
            .join(", ");

        },
      }}
    >

      {optionKeys.map((o) => (

        <MenuItem
          key={o}
          value={String(o)}
        >
          {options[o]}
        </MenuItem>

      ))}

    </TextField>
  );

};

export const SingleSelectField = ({
  field,
  value,
  onChange,
}) => {

  const options =
    field?.options || {};

  const optionKeys =
    Object.keys(options);

  return (
    <TextField
      label={field.label}

      value={
        value !== null &&
        value !== undefined
          ? String(value)
          : ""
      }

      onChange={(e) =>
        onChange(
          e.target.value || null,
        )
      }

      select
      fullWidth
      size="small"
      margin="normal"
    >

      <MenuItem value="">
        Select
      </MenuItem>

      {optionKeys.map((o) => (

        <MenuItem
          key={o}
          value={String(o)}
        >
          {options[o]}
        </MenuItem>

      ))}

    </TextField>
  );

};

export const MultiSelectArrayField = ({
  field,
  value,
  onChange,
}) => {

  const opts =
    field.options || [];

  return (
    <TextField
      label={field.label}

      value={value ?? []}

      onChange={(e) =>
        onChange(
          e.target.value,
        )
      }

      select
      fullWidth
      size="small"
      margin="normal"

      disabled={
        field.isLoading ?? false
      }

      SelectProps={{

        multiple: true,

        renderValue: (
          selected: any,
        ) => {

          if (
            !Array.isArray(selected)
          ) {
            return "";
          }

          return selected.join(
            ", ",
          );

        },

      }}
    >

      {opts.map(
        (
          item: any,
          index: number,
        ) => {

          const val =
            typeof item ===
              "string"
              ? item
              : item.value;

          const label =
            typeof item ===
              "string"
              ? item
              : item.label;

          return (
            <MenuItem
              key={index}
              value={val}
            >
              {label}
            </MenuItem>
          );

        },
      )}

    </TextField>
  );

};

export const hasActiveFilters = (
  filters: Record<string, any>,
) => {

  return Object.values(
    filters,
  ).some((value) => {

    if (
      Array.isArray(value)
    ) {
      return value.length > 0;
    }

    if (
      value &&
      typeof value ===
      "object"
    ) {

      return Object.values(
        value,
      ).some(
        (v) =>
          v !== null &&
          v !== undefined &&
          v !== "",
      );

    }

    return (
      value !== null &&
      value !== undefined &&
      value !== ""
    );

  });

};